import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NavSidebarComponent } from './core/sidebar/components/nav-sidebar/nav-sidebar.component';
import { HeaderComponent } from './core/header/header.component';
import { FooterComponent } from './core/footer/footer.component';
import { InitializationService } from './core/initialization/initialization.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppInitializationStatus } from './core/initialization/initialization.types';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MatSidenavModule,
    MatSlideToggleModule,
    NavSidebarComponent,
    HeaderComponent,
    FooterComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private initializationService = inject(InitializationService);
  appInitializationStatus = toSignal(
    this.initializationService.appInitializationStatus,
  );
  AppInitializationStatus = AppInitializationStatus;
}
